import React, { useState } from "react";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
//primereact
import { Button } from "primereact/button";
//components
import Modal from "../../components/modal/Modal";
import Panel from "../../components/panel/panel";
import Input from "../../components/input/Input";
import FileInput from "../../components/input/FileInput";
import CardDocument from "../../components/cards/CardDocument";
//services
import { getTemporaryUrl } from "../../services/File/getTemporaryUrl";
import { patchProfileDocuments } from "../../services/Profile/patchProfileDocuments";
import { deleteProfileDocuments } from "../../services/Profile/deleteProfileDocuments";

const UserDocuments = ({ documents, setDocuments, refetch, isRefetching }) => {
  const [doc, setDoc] = useState("");
  const [type, setType] = useState("");
  const [visible, setVisible] = useState();
  const [loading, setLoading] = useState();

  const form = useForm();
  const errors = form.formState.errors;

  const deleteDoc = async (id) => {
    const notification = toast.loading("Deletando o Documento...");
    const newDoc = documents.filter((item) => item.id !== id);
    try {
      await deleteProfileDocuments({ documents_id: [ id ] });
      setDocuments(newDoc);
      toast.update(notification, {
        render: "Documento Deletado com Sucesso!",
        autoClose: 5000,
        type: "success",
        isLoading: false,
      });
    } catch (error) {
      toast.update(notification, {
        render: "Oops, algo deu errado!",
        autoClose: 5000,
        type: "error",
        isLoading: false,
      });
    }
  };

  const downloadDoc = async (id) => {
    const notification = toast.loading("Preparando seu download...");
    try {
      const response = await getTemporaryUrl(id);
      // console.log(response);

      const extractFileName = (url) => {
        const matches = url.match(/\/([^\/?#]+)[^\/]*$/);
        if (matches && matches.length > 1) {
          return matches[1];
        }
        return null;
      };

      const fileName = extractFileName(response.url);

      function downloadPDF(url) {
        fetch(url)
          .then((response) => response.blob())
          .then((blob) => {
            const blobURL = URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = blobURL;
            link.setAttribute("download", fileName);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          })
          .catch((error) => {
            console.error("Erro ao fazer o download do PDF:", error);
          });
      }

      downloadPDF(response.url);

      toast.update(notification, {
        render: "Download concluído!",
        autoClose: 5000,
        type: "success",
        isLoading: false,
      });
      return response.url;
    } catch (error) {
      // console.log(error);
      toast.update(notification, {
        render: "Oops, algo deu errado!",
        autoClose: 5000,
        type: "error",
        isLoading: false,
      });
      return null;
    }
  };

  const handleSubmitFile = async (data) => {
    setLoading(true);
    const notification = toast.loading(
      "Aguarde, estamos salvando o arquivo..."
    );
    try {
      await patchProfileDocuments({
        documents: [
          {
            name: data.name,
            file: doc,
            path: type,
            type_file: `my_documents`,
          },
        ],
      });

      refetch().then(() => {
        setVisible(false);
        setLoading(false);
        toast.update(notification, {
          render: "Arquivo Salvo com Sucesso!",
          autoClose: 5000,
          type: "success",
          isLoading: false,
        })
      })
    } catch (error) {
      toast.update(notification, {
        render: "Oops, algo deu errado!",
        autoClose: 5000,
        type: "error",
        isLoading: false,
      });
      setVisible(false);
      setLoading(false);
    }
  };

  return (
    <>
      <Panel title="Documentos">
        <div className="row p-4 d-flex w-100">
          <CardDocument
            description={"Adicionar Documento"}
            type="add"
            onClick={() => setVisible(true)}
          />
          {documents &&
            documents.map((d, index) => {
              if (
                d.type_file === "cadastro_geral_profile_photo" ||
                d.type_file === "profile_photo"
              ) {
                return <></>;
              }

              return (
                <CardDocument
                  key={index}
                  idDoc={d.id}
                  deleteFunction={() => deleteDoc(d.id)}
                  downloadFunction={() => downloadDoc(d.id)}
                  hasLink={typeof d.id === "number"}
                  description={d.name}
                  hasViewFile={true}
                  actions={true}
                  type={d.path.split(".").pop().toLowerCase()}
                />
              );
            })}
        </div>
      </Panel>

      <Modal
        visible={visible}
        position="center"
        onHide={() => setVisible(false)}
        dynamicTitle="Anexar arquivo"
      >
        <form onSubmit={form.handleSubmit(handleSubmitFile)}>
          <Input
            errors={errors}
            control={form.control}
            name="name"
            label="Nome do Arquivo"
            className={"mb-5"}
            isRequired={true}
          />
          <FileInput
            doc="Arquivo"
            name="archive"
            icon="fa-file"
            base64={true}
            setType={setType}
            setSelectedFile={setDoc}
          />
          <div className="d-flex justify-content-end mt-4">
            <Button
              label="Criar"
              icon="pi pi-check"
              type="submit"
              loading={loading}
              autoFocus
            />
          </div>
        </form>
      </Modal>
    </>
  );
};

export default UserDocuments;
